import * as React from 'react';
import { EditOutlined } from '@ant-design/icons';
import ShippingSettingsModal from './components/Modal';
import PriceDisplay from '../../../../components/Others/PriceDisplay';
import { Tag } from 'antd';

interface IShippingSettingsProps {
  order: GQL.IOrder;
  onUpdate: (data: any) => void;
}

interface IShippingSettingsState {
  modalOpened: boolean;
}

function createMarkup(content: string) {
  return { __html: content.replace(/(?:\r\n|\r|\n)/g, '<br />') };
}

class ShippingSettings extends React.Component<IShippingSettingsProps, IShippingSettingsState> {

  constructor(props: IShippingSettingsProps) {
    super(props);

    this.state = {
      modalOpened: false,
    };

    this.onToggleModal = this.onToggleModal.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  
  public render() {
    const { order } = this.props;

    return (
      <React.Fragment>
        <div className="editBlock shipping" onClick={this.onToggleModal}>
          <div className="icon">
            <EditOutlined onClick={this.onToggleModal} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897' }}>Method</span>
            <span>{order.deliveryMethod.title}</span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897' }}>Price</span>
            {order.deliveryTotal === null &&
              <span style={{ color: '#999897' }}>- not specified -</span>}
            {order.deliveryTotal !== null &&
              <span>
                <PriceDisplay amount={order.deliveryTotal} currency={order.currency} />
              </span>}
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897' }}>Recycled box</span>
            <span style={{ color: 'rgba(0, 0, 0, 0.85)', fontWeight: 500, textAlign: 'right', marginRight: '-8px' }}>
              {order.recycledBox
                ? <Tag color={'green'}>Yes</Tag>
                : <Tag color={'red'}>No</Tag>}
            </span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897', width: 170 }}>Shipping tracking link</span>
            {!order.shippingTrackingLink
              ? <span style={{ color: '#999897' }}>- not set -</span>
              : <span style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', width: 'calc(100% - 170px)' }}>
                  <a href={order.shippingTrackingLink} target="_blank">
                    {order.shippingTrackingLink}
                  </a>
                </span>}
          </div>
        </div>

        {this.state.modalOpened &&
          <ShippingSettingsModal 
            order={order}
            onSubmit={this.onSubmit}
            onClose={this.onToggleModal}
          />}
      </React.Fragment>
    );
  }

  private onToggleModal() {
    this.setState({
      modalOpened: !this.state.modalOpened,
    });
  }

  private async onSubmit(data: any) {
    await this.props.onUpdate(data);
    this.onToggleModal();
  }
}

export default ShippingSettings;


// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView/ShippingSettings/ShippingSettings.tsx